import React from 'react';
import { Wrench, Tag } from 'lucide-react';
import BrainBoard from '../components/BrainBoard';
import VendorPricing from '../components/VendorPricing';

// The board itself lives in components/BrainBoard.js, shared with the Accounting
// Brain. This file is only the words and the people. Owners must match the list in
// netlify/functions/lib/procurement-brain-db.js — keep the two in step.
//
// "Matt Sr" here is Matt Cain (admin_id 2), the same person the work spine calls
// 'matt'. Matt Jr is a separate owner and a separate account.
const CONFIG = {
  prefix: 'proc',
  section: 'procurement',
  sectionLabel: 'Procurement',
  title: 'Procurement Brain',
  icon: Wrench,
  briefFn: 'procurement-brief',
  chatGuidance: 'This is buying seafood: crabs from watermen, plus lobster, oysters, clams and the rest from vendors. Prices move daily and the season moves them more, so never quote an old price as if it were current. Matt Sr and Matt Jr buy, and anything that changes what we pay a vendor is theirs or Gregs.',
  owners: ['Matt Sr', 'Matt Jr', 'Greg', 'Claude', 'Mercedes', 'Montel', 'Brenda'],
  counterOwners: ['Matt Sr', 'Matt Jr', 'Claude'],
  ownerRank: ['Matt Sr', 'Matt Jr', 'Greg', 'Montel', 'Brenda', 'Mercedes', 'Claude'],
  blurb: 'How we buy, what we paid, what it graded out to, and what is on each person’s plate. The reasoning behind a buy gets written down here instead of living in one head, so the next question can be answered from what we already know.',
  // Vendor price sheets read out of Greg's "Vendor Pricing" Outlook folder (Oct 26, 2026).
  extraTabs: [{ key: 'vendor-pricing', label: 'Vendor Pricing', icon: Tag, render: () => <VendorPricing /> }],
  docsEmpty: 'No documents stored yet. Buying rules, supplier notes, season write-ups and handoffs get added here so they are readable without hunting through email.',
};

export default function ProcurementBrain() {
  return <BrainBoard config={CONFIG} />;
}
